export default "__VITE_ASSET__C9kyqd_3__"